import { useState } from "react";
import { motion } from "@/components/motion";
import { Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Download } from "lucide-react";
import { categories } from "@/data/products";

const Products = () => {
  const [activeTab, setActiveTab] = useState("pipes");

  const catalogUrl = `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/catalogs/product-catalog.pdf`;

  return (
    <section id="products" className="py-20 md:py-28 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <p className="text-accent-strong font-display text-sm uppercase tracking-[0.2em] mb-2">
            What We Offer
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            Our Product Range
          </h2>
          <p className="font-body text-muted-foreground mt-3 max-w-2xl mx-auto">
            Authorized distributors for Jindal Star, Tata Pipes, Kartar, Zoloto, Normex, Matrix, Racer, VS, Kitz, Nezone, Kranti, APL Apollo & more.
          </p>
          <a
            href={catalogUrl}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="mt-5 inline-flex items-center justify-center gap-2.5 bg-accent text-accent-foreground px-6 py-3 sm:px-7 sm:py-3.5 rounded-md font-display font-semibold text-sm sm:text-base shadow-md hover:shadow-lg hover:brightness-110 transition-all active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          >
            <Download className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" />
            <span>Download Product Catalog</span>
          </a>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="flex flex-wrap justify-center h-auto gap-1 bg-transparent mb-8">
            {categories.map((cat) => (
              <TabsTrigger
                key={cat.id}
                value={cat.id}
                className="font-display text-xs sm:text-sm px-3 sm:px-5 py-2 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground rounded-md"
              >
                {cat.label}
              </TabsTrigger>
            ))}
          </TabsList>

          {categories.map((cat) => (
            <TabsContent key={cat.id} value={cat.id}>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {cat.products.map((p, i) => (
                  <motion.div
                    key={p.title}
                    initial={{ opacity: 0, y: 20, filter: "blur(4px)" }}
                    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                    transition={{
                      duration: 0.5,
                      delay: i * 0.06,
                      ease: [0.16, 1, 0.3, 1],
                    }}
                    className="relative bg-card rounded-lg border border-border p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all group h-full"
                  >
                    <div className="w-10 h-0.5 bg-accent rounded mb-3 group-hover:w-16 transition-all" />
                    <h3 className="font-display text-base font-semibold text-foreground mb-1.5">
                      <Link
                        to={`/products/${p.slug}`}
                        className="after:absolute after:inset-0 after:content-[''] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded"
                      >
                        {p.title}
                      </Link>
                    </h3>
                    <p className="font-body text-muted-foreground text-sm leading-relaxed mb-3">
                      {p.desc}
                    </p>
                    <p className="font-body text-xs font-semibold text-accent-strong uppercase tracking-wider">
                      Sizes: {p.sizes}
                    </p>
                  </motion.div>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default Products;
